import fetch,{getBlob} from '../utils/fetch';

// 查询房屋委托接口
export function cooperationList(params){
    return fetch({
        method: 'GET',
        url: 'cooperation/list',
        params
    })
}

// 查询基础信息
export function getInfo() {
    return fetch({
        method: 'GET',
        url: 'cooperation/getListCondition',
    }) 
}

// 导出商机
export function exportList(data) {
    return getBlob({
        method: 'POST',
        url: 'cooperation/exportCooperationList',
        data
    }) 
}

// 分配商机
export function allocateCooperation(data) {
    return fetch({
        method: 'POST',
        url: 'cooperation/allocateCooperation',
        data
    }) 
}

// 查询物业商机详情
export function getApartmentDetailByFid(params){
    return fetch({
        method: 'GET',
        url: 'cooperation/getApartmentDetailByFid',
        params
    })
}

// 编辑商机
export function handleCooperation(data){
    return fetch({
        method: 'POST',
        url: '/cooperation/handleCooperation',
        data
    })
}

// 获取跟进人 
export function getHandlePerson() {
    return fetch({
        method: 'GET',
        url: 'cooperation/getHandlePerson',
    })
}